// import * as jobsID from '../data/jobID'
export function getBuffsBonuses(newBonuses, getSkillLevel) {
	let buffLevel = 0
	//Increase Agi
	buffLevel = getSkillLevel('AL_INCAGI')
	if (buffLevel) {
		newBonuses['bAgi'] = currentValue(newBonuses, 'bAgi') + (2 + buffLevel)
		newBonuses['bAspdRate'] =
			currentValue(newBonuses, 'bAspdRate') + buffLevel
	}
	//Blessing
	buffLevel = getSkillLevel('AL_BLESSING')
	if (buffLevel) {
		newBonuses['bStr'] = currentValue(newBonuses, 'bStr') + buffLevel
		newBonuses['bDex'] = currentValue(newBonuses, 'bDex') + buffLevel
		newBonuses['bInt'] = currentValue(newBonuses, 'bInt') + buffLevel
		newBonuses['bHit'] = currentValue(newBonuses, 'bHit') + buffLevel * 2
	}
	//Angelus
	buffLevel = getSkillLevel('AL_ANGELUS')
	if (buffLevel) {
		newBonuses['bDef2Rate'] =
			currentValue(newBonuses, 'bDef2Rate') + buffLevel * 5
		newBonuses['bMaxHP'] =
			currentValue(newBonuses, 'bMaxHP') + buffLevel * 50
	}
}

/**
 *
 * @param {*} newBonuses
 * @param {*} bonus
 * @returns if bonus doesn't exist return 0 else return current bonus value
 */
function currentValue(bonusesList, bonus) {
	return bonusesList[bonus] ? bonusesList[bonus] : 0
}
